__turbopack_context__.v({
  "translationBox": "translate-module__62fz-a__translationBox",
  "translationOutputTextArea": "translate-module__62fz-a__translationOutputTextArea",
  "translationTextArea": "translate-module__62fz-a__translationTextArea",
});
